__turbopack_context__.v({
  "subTitle": "breadcrumbs-module__MX9l9W__subTitle",
  "wrapper": "breadcrumbs-module__MX9l9W__wrapper",
});
